import { InfoCircleIcon } from '@/assets/svg';
import { Box, Typography } from '@material-ui/core';
import React from 'react';

export const getFormTextMessage = (message, type = 'error') => {
  let color = '#0B8E5E';
  switch (type) {
    case 'error':
      color = '#DB3D49';
      break;
    case 'success':
      color = '#0B8E5E';
      break;
    default:
      color = '#666666';
  }
  if (!message) {
    return null;
  }

  return (
    <Box display="flex" gridGap={4} alignItems="center">
      <InfoCircleIcon color={color} />
      <Box color={color} fontSize={12}>
        {message}
      </Box>
    </Box>
  );
};
